export class GeoPluginResults {

    private readonly _succeeded: boolean;
    private readonly _errorCode: number;
    private readonly _errorMessage: string;

    constructor (succeeded: boolean = null, errorCode: number = -1, errorMessage: string = '') {
        this._succeeded = succeeded;
        this._errorCode = errorCode;
        this._errorMessage = errorMessage;
    }

    get errorMessage(): string {
        return this._errorMessage;
    }
    get errorCode(): number {
        return this._errorCode;
    }
    get succeeded(): boolean {
        return this._succeeded;
    }
}
